import { QuestionGroupType } from '@exam-management/graphql';
import { Chip, LibraryBooksOutlinedIcon, FolderOpenOutlinedIcon } from '@shared/components';
import { capitalize } from '@shared/utils';

const QUESTION_TYPE_TEXT = {
  [QuestionGroupType.Single]: capitalize(QuestionGroupType.Single),
  [QuestionGroupType.ItemSet]: 'Item Set',
  [QuestionGroupType.LotOfQuestion]: 'LOQ',
};

const QUESTION_TYPE_ICON = {
  [QuestionGroupType.ItemSet]: (
    <LibraryBooksOutlinedIcon
      color='warning'
      sx={{
        width: 16,
        height: 16,
        '&.MuiChip-icon': {
          m: 0,
        },
      }}
    />
  ),
  [QuestionGroupType.LotOfQuestion]: (
    <FolderOpenOutlinedIcon
      color='warning'
      sx={{
        width: 16,
        height: 16,
        '&.MuiChip-icon': {
          m: 0,
        },
      }}
    />
  ),
  [QuestionGroupType.Single]: undefined,
};

export interface QContentQuestionTypeChipProps {
  type: QuestionGroupType;
}

export default function QContentQuestionTypeChip(props: Readonly<QContentQuestionTypeChipProps>) {
  const { type } = props;

  return (
    <Chip
      label={QUESTION_TYPE_TEXT[type]}
      variant='outlined'
      color='primary'
      sx={(theme) => ({
        color: theme.palette.grey[700],
        px: theme.spacing(3),
      })}
      icon={QUESTION_TYPE_ICON[type]}
    />
  );
}
